import { render, staticRenderFns } from "./retog.vue?vue&type=template&id=16832fa2&"
import script from "./retog.vue?vue&type=script&lang=js&"
export * from "./retog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports